import { ProductType } from '@/types';
import { getHasWarning } from './getHasWarning';
import { WarningTypes } from './warningTypes';

export const getIsAdultDesignsVerboten = (productType: ProductType) =>
  getHasWarning(productType, WarningTypes.SafeDesigns);
